import Heading from 'LearningManager/components/Heading';
import styles from 'LearningManager/styles/CustomSetup.module.scss';
import CheckBoxCard from 'LearningManager/components/CheckBoxCard';
import { Icon, Input } from 'Components';
import MultiSelectDropdown from 'LearningManager/components/MultiSelectDropdown';
import { useStepper } from 'LearningManager/hooks/Stepper.context';

interface optionsProps {
	id: number;
	title: string;
	desc: string;
}

const options: optionsProps[] = [
	{
		id: 1,
		title: 'Alice Johnson',
		desc: 'ajohnson@gplaza.com'
	},
	{
		id: 2,
		title: 'Benjamin Smith',
		desc: 'bsmith@gplaza.com'
	},
	{
		id: 3,
		title: 'Charlotte Brown',
		desc: 'cbrown@marriott.com'
	},
	{
		id: 4,
		title: 'David Wilson',
		desc: 'dwilson@marriott.com'
	},
	{
		id: 5,
		title: 'Emily Davis',
		desc: 'edavis@marriott.com'
	},
	{
		id: 6,
		title: 'Frank Miller',
		desc: 'fmiller@marriott.com'
	},
	{
		id: 7,
		title: 'Grace Lee',
		desc: 'glee@marriott.com'
	},
	{
		id: 8,
		title: 'Henry Taylor',
		desc: 'htaylor@marriott.com'
	}
];

const Individual = () => {
	const {
		draft: {
			customSetup: {
				selectedIndividualUserIds,
				selectedIndividualPropertyIds
			}
		},
		toggleAssignUsersSelection,
		setAssignUsersSelection,
		setAssignUsersPropertyFilter
	} = useStepper();

	const handleCheckboxChange = (id: number, checked: boolean) => {
		if (checked !== selectedIndividualUserIds.includes(id)) {
			toggleAssignUsersSelection('selectedIndividualUserIds', id);
		}
	};

	const handleSelectAll = () => {
		if (selectedIndividualUserIds.length === options.length) {
			setAssignUsersSelection('selectedIndividualUserIds', []);
		} else {
			setAssignUsersSelection(
				'selectedIndividualUserIds',
				options.map((opt) => opt.id)
			);
		}
	};

	const properties = [
		{ id: 1, label: 'Pyramid Hotel' },
		{ id: 2, label: 'Marriott Hotel' },
		{ id: 3, label: 'Grand Plaza' },
		{ id: 4, label: 'Ocean View Resort' }
	];

	const handleChange = (ids: number[]) => {
		setAssignUsersPropertyFilter('selectedIndividualPropertyIds', ids);
	};

	const isAllSelected = selectedIndividualUserIds.length === options.length;

	return (
		<div>
			<div>
				<Heading />
				<div className={styles.filters}>
					<div className={styles.search}>
						<div className={styles.selectProp}>Select Property</div>
						<MultiSelectDropdown
							options={properties}
							placeholder="Select option"
							onChange={handleChange}
							defaultSelectedIds={selectedIndividualPropertyIds}
						/>
					</div>
					<Input.Search
						className={styles.search}
						placeholder="Search"
						suffix={<Icon type="search" role="img" />}
					/>
				</div>
			</div>
			<div className={styles.header}>
				<Heading
					titleClassName={styles.title}
					title="Select properties"
					astrix={true}
				/>
				{options.length > 1 && (
					<div
						className={styles.selectAllBtn}
						onClick={handleSelectAll}
					>
						{isAllSelected ? 'Deselect all' : 'Select all'}
					</div>
				)}
			</div>
			<div className={styles.container}>
				{options.map((option) => (
					<CheckBoxCard
						key={option.id}
						id={option.id}
						icon={<Icon type="groupOptIcon" />}
						title={option.title}
						desc={option.desc}
						isChecked={selectedIndividualUserIds.includes(option.id)}
						onChange={handleCheckboxChange}
					/>
				))}
			</div>
		</div>
	);
};

export default Individual;
